import React, { useState } from "react";
import { Button, Flex, Modal, Notification, Text, TextField } from "@telia/teddy";
import { API_URL_SET_SALES_AGENT_PASSWORD } from "../../api";
import { retailerFetch } from "../../retailerFetch";
import { SalesAgent } from "../../types/models";

interface Props {
    agent: SalesAgent;
    onClose: () => void;
}

const SetPasswordModal: React.FC<Props> = ({ agent, onClose }) => {
    const [newPassword, setNewPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const handleSave = () => {
        if (!newPassword.trim()) {
            setError("Passord er påkrevd");
            return;
        }
        setSubmitting(true);
        setError(null);
        retailerFetch(API_URL_SET_SALES_AGENT_PASSWORD, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                salesAgentId: agent.id,
                password: newPassword,
                tcadUserId: agent.tcadUserId,
            }),
        })
            .then((res) => {
                if (!res.ok)
                    return res.text().then((text) => {
                        let msg = `Feil (${res.status})`;
                        try {
                            msg = JSON.parse(text)?.error ?? msg;
                        } catch {
                            // server returned non-JSON (e.g. HTML error page)
                        }
                        throw new Error(msg);
                    });
                setSuccess(true);
            })
            .catch((err: Error) => setError(err.message))
            .finally(() => setSubmitting(false));
    };

    return (
        <Modal defaultOpen open>
            <Modal.Overlay>
                <Modal.Content>
                    <Modal.Title as="h3">Nytt passord</Modal.Title>
                    <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                    <Modal.Group direction="column">
                        <Text variant="additional-100">
                            {agent.firstName} {agent.lastName}
                        </Text>
                        {error && (
                            <Notification type="tile" variant="error" mt="200">
                                <Notification.Icon />
                                <Notification.Text>{error}</Notification.Text>
                            </Notification>
                        )}
                        {success ? (
                            <Notification type="tile" variant="success" mt="200">
                                <Notification.Icon />
                                <Notification.Text>Passord er oppdatert.</Notification.Text>
                            </Notification>
                        ) : (
                            <TextField>
                                <TextField.Label>Nytt passord</TextField.Label>
                                <TextField.Input
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    type="password"
                                    autoComplete="new-password"
                                    data-di-mask
                                />
                            </TextField>
                        )}
                    </Modal.Group>
                    <Modal.Group direction="column" variant="action">
                        <Flex gap="200" mt="300">
                            {!success && (
                                <Button
                                    variant="primary"
                                    loading={submitting}
                                    disabled={submitting}
                                    onClick={handleSave}
                                >
                                    Lagre
                                </Button>
                            )}
                            <Button variant="secondary" onClick={onClose}>
                                {success ? "Lukk" : "Avbryt"}
                            </Button>
                        </Flex>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default SetPasswordModal;
